import { useAuth } from '@/services/auth';
import { useFlag } from '@/services/featureFlags';
import { AppRoutes } from '@/utils/types';
import code from '../images/code.svg';
import dialog from '../images/dialog.svg';
import plain from '../images/plain.svg';
import translation from '../images/translation.svg';
import usersGroup from '../images/users-group.svg';
import videos from '../images/videos.svg';
import widget from '../images/widget.svg';

export interface SidebarRoute {
    id: string;
    path: string;
    icon: string;
    label: string;
    newTab?: boolean;
    isBeta?: boolean;
    extraAnalyticsData?: Record<string, any>;
}

const sideBarVideo = {
    id: 'sidebar-video-studio',
    path: AppRoutes.VideoStudio,
    icon: videos,
    label: 'Video Studio',
};

const sideBarAgents = {
    id: 'sidebar-agents',
    path: AppRoutes.Agent,
    icon: dialog,
    label: 'Agents',
};

const sideBarAvatars = {
    id: 'sidebar-avatars',
    path: AppRoutes.Avatars,
    icon: usersGroup,
    label: 'Avatars',
};

const sideBarTranslation = {
    id: 'sidebar-translation',
    path: AppRoutes.Translation,
    icon: translation,
    label: 'Video Translate',
};

const sideBarCampaigns = {
    id: 'sidebar-video-campaigns',
    path: AppRoutes.Campaigns,
    icon: plain,
    label: 'Video Campaigns',
};

const sideBarBackoffice = {
    id: 'sidebar-backoffice',
    path: AppRoutes.Backoffice,
    icon: plain,
    label: 'Backoffice',
};

export const useSidebarRoutes = (): SidebarRoute[] => {
    const { isAnonymous } = useAuth();
    const backofficeEnabled = useFlag('backoffice_is_enabled', false);
    const campaignsEnabled = useFlag('campaigns_is_enabled', false);

    const routes: SidebarRoute[] = [
        sideBarVideo,
        sideBarTranslation,
        sideBarAgents,
        ...(campaignsEnabled ? [sideBarCampaigns] : []),
        sideBarAvatars,
        {
            id: 'sidebar-api',
            path: AppRoutes.Docs,
            icon: code,
            label: 'API',
            newTab: true,
            extraAnalyticsData: { redirect: isAnonymous ? 'login' : 'readmeio' },
        },
        {
            id: 'divider',
            path: '',
            icon: '',
            label: '',
        },
        {
            id: 'sidebar-apps',
            path: AppRoutes.Apps,
            icon: widget,
            label: 'Apps',
        },
        ...(backofficeEnabled ? [sideBarBackoffice] : []),
    ];

    return routes;
};
